var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassPanel", {
    attrs: { value: _vm.showPanel, title: _vm.panelTitle },
    on: { beforeClose: _vm.closePanel },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _vm.effectiveTemplate && _vm.currentStep
              ? _c(
                  "div",
                  { staticClass: "automation-wizard-panel__content" },
                  [
                    _vm.currentStep.type === "overview"
                      ? _c("AutomationWizardOverviewContainer", {
                          attrs: {
                            template: _vm.effectiveTemplate,
                            isEditMode: _vm.isEditMode
                          }
                        })
                      : _c("AutomationWizardForm", {
                          attrs: { currentStep: _vm.currentStep },
                          on: { "field-change": _vm.clearFieldError },
                          model: {
                            value: _vm.formData,
                            callback: function($$v) {
                              _vm.formData = $$v
                            },
                            expression: "formData"
                          }
                        })
                  ],
                  1
                )
              : _vm._e()
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c("AutomationWizardPanelFooter", {
              attrs: {
                allSteps: _vm.allSteps,
                currentStepIndex: _vm.currentStepIndex,
                isLoading: _vm.isLoadingActivate,
                isEditMode: _vm.isEditMode
              },
              on: {
                "activate-automation": _vm.handleActivateAutomation,
                "previous-step": _vm.goToPreviousStep,
                "next-step": _vm.handleNextStep
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }